import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48df4d87"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faces" }
const _hoisted_2 = ["src", "alt", "title", "onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))

import FaceUtils from "@/utils/FaceUtils";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Faces',
  emits: ["insertFace"],
  setup(__props, { emit }) {

const faceList = ref(FaceUtils.alt);
const faceMap = ref(FaceUtils.faces());

const insertFace = (item: string) => {
  emit("insertFace", item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faceList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createElementVNode("img", {
            src: faceMap.value.get(item),
            alt: item,
            title: item,
            onClick: ($event: any) => (insertFace(item))
          }, null, 8, _hoisted_2)
        ]))
      }), 128))
    ]),
    _hoisted_3
  ]))
}
}

})